import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { emitEvent } from '../../utils/dom';
import { EVENT_NAMES } from '../../constants/events';
import { SELECTORS } from '../../constants/selectors';

/**
 * @element kd-header-drawer
 * @description ハンバーガーメニューのクリックを検知し、kd-header-menu-toggle イベントを発火する。
 * layout/v2-theme.liquid の [data-sp-drawer] 側でイベントを受信してドロワーを開閉する。
 */
@customElement('kd-header-drawer')
export class KdHeaderDrawer extends LitElement {
  createRenderRoot() {
    return this;
  }

  /** クリックハンドラの参照 */
  private handleClick: ((e: Event) => void) | null = null;

  render() {
    return nothing;
  }

  connectedCallback(): void {
    super.connectedCallback();

    this.handleClick = (e: Event) => {
      e.preventDefault();
      emitEvent(this, EVENT_NAMES.HEADER.MENU_TOGGLE, {});
    };

    const trigger = document.querySelector<HTMLElement>(
      SELECTORS.HEADER.MENU_TRIGGER,
    );
    trigger?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    if (this.handleClick) {
      const trigger = document.querySelector<HTMLElement>(
        SELECTORS.HEADER.MENU_TRIGGER,
      );
      trigger?.removeEventListener('click', this.handleClick);
      this.handleClick = null;
    }
  }
}
